const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
const DEFAULT_PAGE_SIZE = 10;
const PAGE_SIZE_STORAGE_KEY = 'pageSize';

export { PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE, PAGE_SIZE_STORAGE_KEY };
